/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Role_Permissions_InvalidInputs */

const en_error_role_permissions_invalid = /** @type {(inputs: Error_Role_Permissions_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some of these permissions no longer exist: reload and try again.`)
};

/**
* | output |
* | --- |
* | "Some of these permissions no longer exist: reload and try again." |
*
* @param {Error_Role_Permissions_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_role_permissions_invalid = /** @type {((inputs?: Error_Role_Permissions_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Role_Permissions_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_role_permissions_invalid(inputs)
});